import React, { Component } from 'react';
import FooterComponent from './../../Generic/Footer/FooterComponent';
import HeaderComponent from './../../Generic/Header/HeaderComponent';
import OrderDetails from './OrderDetails/OrderDetails';
import BreadCrumbs from './../../Generic/BreadCrumbs/BreadCrumbs';
import CustomerDetails from './CustomerDetails/CustomerDetails';
import EmptyCart from './EmptyCart';

import * as service from './../../../Service/service';
import * as endpoints from './../../../Service/endpoints';

import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

class CartComponent extends Component {

    state = {
        cart: {
            cartProductList: []
        },
        slugs: [],
        showCart: false,
        billing: {},
        razorpayInfo: {},
        orderData: {},
        paymentConfirmation: false,
        razorPayKey: '',
        isupdating: false,
        isMed: false,
        enquiryData: {},
        isPremium: false,
        isValidOrder: false,
        isAccepted: false,
        isExpress: false,
        isExpressAccepted: false,
        expressDeliveryCharge: null,
        expectedDeliveryDate: null,
        expressProducts: {
            productId: [],
            quantity: []
        },
        quantity: 1,
    }

    onAccept = () => {

        this.setState(
            prevState => ({ isAccepted: !prevState.isAccepted }),
        );
    };

    onAcceptExpressDelivery = () => {
        this.setState(prevState => ({
            isExpressAccepted: !prevState.isExpressAccepted


        }));
        if (this.state.isExpress ) {
            const deliveryDay = this.getExpectedDeliveryDateNumber();
            this.setState({ expectedDeliveryDate: deliveryDay }); 
        }
        console.log('Express delivery date :', this.state.expectedDeliveryDate);
        console.log('Express checkbox selected:', this.state.isExpressAccepted);

    };



    getRazorPayKeys = () => {

        service.razorPayKeys().then((response) => {
            this.setState({
                razorPayKey: response.data
            });

        }, (error) => {
            console.log(error);
        });
    }

    checkExpressDelivery = () => {
        if (this.state.isExpress) {
            console.log("entered express2");
            service.getExpressPrice().then((response) => {
                const cartPriceObj = response.data.find(
                    (item) => item.priceType === "cart"
                );

                this.setState({
                    expressDeliveryCharge: cartPriceObj.price
                })
            }).catch((err) => { console.error(err) })
        }
    }
    checkCart = () => {
        this.setState({ showCart: false, isExpress: false });
        const currentCity = endpoints.getCurrentCity();
        service.checkCart().then((response) => {
            if (response.data?.cartProductList?.length) {
                let slugs = [];
                let prodId = [];
                let quantity = [];
                response.data.cartProductList.forEach((product) => {
                    if (product.isMedical && !this.state.isMed) {
                        this.setState({ isMed: true });
                    }
                    if (product.productSlug) {
                        slugs.push(product.productSlug);
                        if (product.isExpress && currentCity === "gurgaon" ) {
                            prodId.push(product.productId);
                            quantity.push(product.quantity);
                            console.log("entered express");
                            this.setState({ isExpress: true });
                        }
                    }
                });


                this.setState({
                    cart: response.data,
                    slugs: slugs,
                    expressProducts: {
                        productId: prodId,
                        quantity: quantity,
                    },
                });

                this.checkExpressDelivery();
                setTimeout(() => {
                    this.cartProductInfo();
                }, 100);
            }
        }).catch((error) => {
            console.log("Error in checkCart:", error);
        });
    };


    cartProductInfo = () => {

        let cart = JSON.parse(JSON.stringify(this.state.cart));
        let premiumCount = 0;
        let totalProducts = cart.cartProductList.length;


        service.cartProductInfo(this.state.slugs).then((response) => {

            response.data.map((prod) => {

                cart.cartProductList.map((cartProduct) => {
                    if (cartProduct.productSlug === prod.slug) {
                        cartProduct.productInfo = prod;
                        // console.log('cart', cartProduct.productInfo);
                        console.log(`Inventory for ${prod.slug}:`, prod.inventory);
                    }
                });
                if (prod.category.slug === 'premium') {
                    premiumCount++;

                }

            });
            const isOnlyPremium = premiumCount === totalProducts;
            const isOnlyNonPremium = premiumCount === 0;
            const isValidOrder = isOnlyPremium || isOnlyNonPremium;
            // console.log(isOnlyNonPremium, isOnlyPremium, isValidOrder)

            this.setState({
                ...this.state,
                cart: cart,
                showCart: true,
                isValidOrder: isValidOrder,
                isPremium: isOnlyPremium,

            });

            setTimeout(() => {
                this.calculateBilling();
            }, 100);

        }, (error) => {
            console.log(error);
        });
    }

    calculateBilling = () => {
        let billing = {
            totalRent: 0,
            totalDeposit: 0,
            deliveryFee: 0,
            couponDiscount: 0,
            payable: 0
        };

        let seasonalRent = 0; // to track seasonal products' rent separately
        let nonSeasonalRent = 0; // to track non-seasonal products' rent separately

        if (this.state.isPremium) {
            this.state.cart.cartProductList.map((products) => {
                const rent = Number(products.monthlyRent) || 0;

                billing.totalRent += rent;
                billing.totalDeposit += rent * 11;
                billing.payable += rent * 12;
                nonSeasonalRent += rent;
            });
        } else {
            this.state.cart.cartProductList.map((products) => {
                const rent = Number(products.monthlyRent) || 0;

                if (products.productInfo.category.slug === 'seasonal') {
                    billing.totalRent += rent;
                    billing.totalDeposit += 0;
                    billing.payable += rent;
                    seasonalRent += rent;
                } else {
                    billing.totalRent += rent;
                    billing.totalDeposit += rent;
                    billing.payable += rent * 2;
                    nonSeasonalRent += rent;
                }
            });
        }

        if (this.props.coupon.applied && nonSeasonalRent > this.props.coupon.couponDetails.minAmount) {
            let discount = 0;

            if (this.props.coupon.couponDetails.promotionType === "%") {
                discount = (nonSeasonalRent * (parseFloat(this.props.coupon.couponDetails.promotionValue) / 100));
                if (discount > this.props.coupon.couponDetails.maxDiscount) {
                    discount = this.props.coupon.couponDetails.maxDiscount;
                }
            } else if (this.props.coupon.couponDetails.promotionType === "-") {
                discount = parseFloat(this.props.coupon.couponDetails.promotionValue);
            }

            billing.couponDiscount = discount;

            // Now only reduce discount from non-seasonal rent
            billing.totalRent = seasonalRent + (nonSeasonalRent - discount);

            // Recalculate deposit accordingly
            if (this.state.isPremium) {
                billing.totalDeposit = (nonSeasonalRent - discount) * 11 + (seasonalRent * 0);
            } else {
                billing.totalDeposit = (nonSeasonalRent - discount) * 1 + (seasonalRent * 0);
            }

            billing.payable = parseFloat((billing.totalRent + billing.totalDeposit).toFixed(2));
        }

        this.setState({
            ...this.state,
            billing: billing
        });
    }


    getExpectedDeliveryDateNumber = () => {
         const now = new Date();
  const deliveryDate = new Date(now);

  if (now.getHours() >= 13) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }

  // Convert to ISO 8601 string, then remove milliseconds and 'Z' if needed
  const isoString = deliveryDate.toISOString().split('.')[0]; // e.g., "2025-07-10T00:00:00"

  return isoString;
    };

    syncCartQuantities = () => {
        const cartProducts = this.state.cart.cartProductList;

        return Promise.all(
            cartProducts.map((product) =>
                service.manageQuantity({
                    productSlug: product.productSlug,
                    quantity: product.quantity
                })
            )
        ).then(() => service.checkCart())
            .then((response) => {
                const serverQuantities = new Map(
                    (response.data.cartProductList || []).map((product) => [
                        product.productSlug,
                        Number(product.quantity)
                    ])
                );
                const quantityMismatch = cartProducts.some((product) =>
                    serverQuantities.get(product.productSlug) !== Number(product.quantity)
                );

                if (quantityMismatch) {
                    throw new Error('The server did not save the selected cart quantities.');
                }
            });
    };
    
        

    placeOrder = (addressId) => {
        var rent = Math.round(this.state.billing.totalRent);
        const currentCity = endpoints.getCurrentCity();
        if (this.state.isExpress ) {
            const deliveryDay = this.getExpectedDeliveryDateNumber();
            this.setState({ expectedDeliveryDate: deliveryDay }); 
        }

        if (currentCity.indexOf("gur") !== -1) {
            if (rent < 400 && !this.state.isPremium) {
                alert("Minimum monthly rental amount to place order is Rs.400");
                return;
            }
        } else if (rent < 1000 && !this.state.isPremium) {
            alert("Minimum monthly rental amount to place order is Rs.1000");
            return;
        }

        // Prevent order placement if all products are not premium
        if (!this.state.isValidOrder) {
            alert("Only premium products can be ordered. Please remove non-premium products from the cart.");
            return;
        }

        if (addressId !== 0) {
            this.setState({
                ...this.state,
                isupdating: true,
            });

            var orderData = {
                addressId: addressId,
                cart: this.state.cart.cartProductList,
                couponId: this.props.coupon.couponCode,
                couponDiscount: this.state.billing.couponDiscount,
                isMedical: this.state.isMed,
                isPremium: this.state.isPremium,
                creditCheckConsent: this.state.isAccepted,
                expressDeliveryCharge: this.state.expressDeliveryCharge,
                expectedDeliveryDate: this.state.expectedDeliveryDate
            };

            // Razorpay receives its amount from the server-created order. Ensure the
            // server cart has every selected quantity before creating that order.
            this.syncCartQuantities()
                .then(() => service.placeOrder(orderData))
                .then((response) => {
                    this.setState({
                        ...this.state,
                        orderData: response.data,
                        isupdating: false
                    });

                    if (response.data !== null && this.state.isMed !== true) {
                        this.generateRazorPayOrderId(response.data.orderNumber);
                    }
                    if (response.data !== null && this.state.isMed === true) {
                        this.props.updateCurrentOrder(response.data);
                        setTimeout(() => {
                            this.props.history.push('/order/success');
                        }, 100);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ isupdating: false });
                    alert('Unable to confirm the selected quantities. Please refresh the cart and try again before payment.');
                });
        } else {
            alert("This area is not applicable for delivery");
        }
    };


    generateRazorPayOrderId = (orderNumber) => {
        service.getRazorpayOrderId(orderNumber).then((response) => {
            this.setState({
                ...this.state,
                razorpayInfo: response.data
            });

            setTimeout(() => {
                this.initiatePayment();
            }, 100);
        }, (error) => {
            console.log(error);
        });
    }

    initiatePayment = () => {
        var options = {
            "key": this.state.razorPayKey,
            "amount": this.state.razorpayInfo.amount_due,
            "currency": this.state.razorpayInfo.currency,
            "name": "Voorent Pvt. Ltd",
            "description": "",
            "image": "https://voorent.com/voorent-storage/application/voorent.png",
            "order_id": this.state.razorpayInfo.id,
            "handler": (response) => {
                this.updateRazorpayPayments(response);
            },
            "modal": {
                "ondismiss": () => {
                    this.props.history.push('/order/failure');
                }
            },
            "prefill": {
                "name": `${this.props.userInfo.firstName} ${this.props.userInfo.lastName}`,
                "email": `${this.props.userInfo.email}`,
                "contact": `${this.props.userInfo.contact}`
            },
            "theme": {
                "color": "#01497f"
            }
        };

        var rzp1 = new window.Razorpay(options);
        rzp1.open();
    }

    updateRazorpayPayments = (paymentUpdate) => {

        this.setState({
            ...this.state,
            isupdating: true
        });

        let obj = {
            razorpayPaymentId: paymentUpdate.razorpay_payment_id,
            razorpayOrderId: paymentUpdate.razorpay_order_id,
            razorpaySignature: paymentUpdate.razorpay_signature,
            orderNumber: this.state.orderData.orderNumber
        };

        service.updatePayment(obj).then((response) => {

            this.setState({
                ...this.state,
                paymentConfirmation: response.data,
                isupdating: false
            });
            if (response.data) {
                //payment success
                this.props.updateCurrentOrder(this.state.orderData);
                //this.createSubscription(this.state.orderData.orderNumber);
                //call the product update api
                service.updateProductQuantity(this.state.expressProducts);

                setTimeout(() => {
                    this.props.history.push('/order/success');
                }, 100);

            } else {
                //payment failure
            }

        }, (error) => {
            console.log(error);
        });
    }

    createSubscription = (orderNumber) => {

        service.getRazorpaySubscriptionId(orderNumber).then((response) => {
            this.setState({
                ...this.state
            });

        }, (error) => {
            console.log(error);
        });


    }

    deleteProductFromCart = (productSlug) => {

        let productList = this.state.cart.cartProductList;
        productList.map((elem, index) => {
            if (elem.productSlug == productSlug) {
                productList.splice(index, 1);
            }
        });

        this.setState({
            ...this.state,
            cart: {
                ...this.state.cart,
                cartProductList: productList
            }
        });

        service.deleteCartItem(productSlug).then((response) => {
            if (response.status == 200) {
                this.checkCart();
            }
        }, (error) => {
            console.log(error);
        })
    }

    manageQuantity = (operator, slug) => {

        let product = {
            quantity: 1,
            productSlug: slug
        };

        let tmpState = this.state;
        tmpState.cart.cartProductList.map((item) => {
            if (item.productSlug === slug && item.quantity > 1 || operator == 'add') {
                item.quantity = operator == 'add' ? item.quantity += 1 : item.quantity -= 1;
                product.quantity = item.quantity;
            }
        });

        this.setState(tmpState);

        service.manageQuantity(product).then((response) => {
            if (response.status == 200) {
                this.checkCart();
            }
        }, (error) => {
            console.log(error);
        });
    }
    manageQuantityCart = (operator, slug) => {
        let updatedQuantity = null;
        const updatedCartList = this.state.cart.cartProductList.map(item => {
            if (item.productSlug === slug && item.productInfo) {
                const maxInventory = item.productInfo.inventory || 0;

                if (operator === 'add') {
                    if (item.quantity < maxInventory) {
                        updatedQuantity = item.quantity + 1;
                        const unitRent = item.monthlyRent / item.quantity;
                        return { ...item, quantity: updatedQuantity, monthlyRent: unitRent * updatedQuantity, securityDeposit: unitRent * updatedQuantity };
                    } else {
                        alert(`You can only add up to ${maxInventory} items.`);
                    }
                } else if (operator === 'sub') {
                    if (item.quantity > 1) {
                        updatedQuantity = item.quantity - 1;
                        const unitRent = item.monthlyRent / item.quantity;
                        return { ...item, quantity: updatedQuantity, monthlyRent: unitRent * updatedQuantity, securityDeposit: unitRent * updatedQuantity };
                    }
                }
            }
            return item;
        });

        if (updatedQuantity === null) {
            return;
        }

        this.setState(
            {
                cart: {
                    ...this.state.cart,
                    cartProductList: updatedCartList
                }
            },
            () => {
                this.calculateBilling();
                service.manageQuantity({ productSlug: slug, quantity: updatedQuantity })
                    .catch((error) => console.log(error));
            }
        );
    }


    checkIfEmpty = () => {
        if (this.state.cart.cartProductList.length == 0) {
            return (<EmptyCart />);
        } else {
            return (
                <React.Fragment>
                    <div className="row ">
                        <div className="col-12 col-md-8" style={{ position: 'relative', borderRadius: '4px' }}>
                            <OrderDetails
                                isMedical={this.state.isMed}
                                isPremium={this.state.isPremium}
                                calculateBilling={this.calculateBilling}
                                manageQuantity={this.manageQuantity}
                                deleteProductFromCart={this.deleteProductFromCart}
                                cart={this.state}
                                isAccepted={this.state.isAccepted}
                                onAccept={this.onAccept}
                                expressDeliveryCharge={this.state.expressDeliveryCharge}
                                onAcceptExpressDelivery={this.onAcceptExpressDelivery}
                                isExpress={this.state.isExpress}
                                isExpressAccepted={this.state.isExpressAccepted}
                                manageQuantityCart={this.manageQuantityCart}
                            />
                        </div>
                        <div className="col-12 col-md-4" style={{ position: 'relative', borderRadius: '4px' }}>
                            <CustomerDetails placeOrder={this.placeOrder} isMedical={this.state.isMed} updating={this.state.isupdating} isAccepted={this.state.isAccepted} manageQuantityCart={this.manageQuantityCart} />

                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }


    componentDidMount() {
        this.checkCart();
        this.getRazorPayKeys();
        this.props.updateBreadcumbs({
            navigation: [{ name: 'Home', link: './' }, { name: 'Cart', link: '#' }],
            showSidebar: false,
            sidebar: []
        });
    }

    render() {
       
        console.log('express elivery ', this.state.expressProducts)
        console.log('cartinventory', this.state.quantity)
        
        return (
            <React.Fragment>
                <Helmet>
                    <link rel="canonical" href="https://voorent.com/cart" />
                </Helmet>
                <HeaderComponent />
                <BreadCrumbs />
                <main role="main" className="container mt-5">
                    <div className="row">

                        {
                            this.checkIfEmpty()
                        }

                    </div>
                </main>
                <FooterComponent />
            </React.Fragment>
        );
    }
}
const mapStateToProps = (currentState) => {
    return {
        order: currentState.order,
        userInfo: currentState.userState.userInfo,
        coupon: currentState.coupon
    };
};

const mapActionsToProps = (dispatch) => {
    return {
        updateCurrentOrder: (data) => {
            dispatch({ type: 'update.order.current', data: data });
        },
        updateBreadcumbs: (data) => {
            dispatch({ type: 'breadcrumbs.update', data: data });
        }
    };
}


export default connect(mapStateToProps, mapActionsToProps)(CartComponent);
